export default {"src":"/_next/static/media/WhatsappHeader.352a0e7d.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};